
<mat-card appearance="outlined" STYLE="max-width: 570px; margin: 10px;">
  <mat-card-header>
    <div mat-card-avatar>

      <i class="material-icons">
        dynamic_form
      </i>
    </div>
    <mat-card-title>{{this.FormSubmitted.Form.Name}}</mat-card-title>
    <mat-card-subtitle>
      <table>
        <tr>
          <td  >
            <mat-icon>today</mat-icon>
          </td>
          <td >
            {{this.FormSubmitted.DocumentDate | date:'yyyy-MM-dd'}}
          </td>
        </tr>
        <tr>
          <td  >
            <img _ngcontent-swi-c109="" src="../../assets/img/shield.png" style="height: 20px;">
          </td>
          <td  >
            {{this.FormSubmitted.TeamName}}

          </td>
        </tr>

        <!-- <tr *ngIf="this.FormSubmitted.Player">
        <td style="color:white;">
          <mat-icon>person</mat-icon>

        </td>
        <td >
          <a [routerLink]="['/player/details', this.FormSubmitted.PlayerId]" style="color: white;">
            {{this.FormSubmitted.Player.Player.LastName}},{{this.FormSubmitted.Player.Player.FirstName}}
          </a>
        </td>
      </tr> -->
      @if (false) {
        <tr>
          <td  >
            Game:
          </td>
          <td >
          </td>
        </tr>
      }

    </table>
    @if (this.FormSubmitted.Player) {
      <app-player-details-section  [Player]="this.FormSubmitted.Player.Player"></app-player-details-section>
    }
    <br/>

    <button mat-icon-button (click)="this.Minimized=!this.Minimized">
      <!--           <span *ngIf="this.Minimized">EXPAND</span>
      <span *ngIf="!this.Minimized">HIDE</span> -->
      @if (this.Minimized) {
        <mat-icon>expand_more</mat-icon>
      }
      @if (!this.Minimized) {
        <mat-icon>expand_less</mat-icon>
      }
    </button>
  </mat-card-subtitle>

</mat-card-header>
<mat-card-content class="CardContent">




  <mat-divider></mat-divider>
  @if (!this.Minimized) {
    @for (section of this.FormSubmitted.Form.FormVersion.Sections; track section) {
      <div class="Section" >
        {{section.Text}}
        <table style="width: 100%; margin-left: 10px;">
          @for (question of section.Questions; track question) {
            @switch (question.ValueType) {
              @case ('Text') {
                <tr  class="Question">
                  <td class="QuestionText">
                    {{question.Text}}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2">
                    @if (question.Answer) {
                      <div  style="margin-left: 5px; border-left: white solid 2px; padding: 3px;">
                        {{question.Answer.TextValue}}
                      </div>
                    }
                  </td>
                </tr>
              }
              @case ('Integer') {
                <tr>
                  <td class="QuestionText">
                    {{question.Text}}
                  </td>
                  <td  class="AnswerText">
                    @if (question.Answer && question.Answer.IntValue>0) {
                      <div  [class]="this.getValueClass(question.ControlType, question.Answer.IntValue)">
                        {{question.Answer.IntValue}}
                      </div>
                    }
                  </td>
                </tr>
              }
              @case ('DateTime') {
                <tr>
                  <td class="QuestionText">
                    {{question.Text}}
                  </td>
                  <td class="AnswerText">
                    @if (question.Answer) {
                      <span  >
                        {{question.Answer.DateValue | date: "YYYY-MM-dd"}}
                      </span>
                    }
                  </td>
                </tr>
              }
            }
          }
        </table>
        @for (question of section.Questions; track question) {
          <div class="Question">
            <!-- {{Question.Answer.TextValue}} -->
          </div>
        }
      </div>
    }
    <mat-divider></mat-divider >
    <table style="color:gray; font-size: small;"  >
      <tr>
        <td>Created by:</td>
        <td style="color: white">{{this.FormSubmitted.SubmittedByUser.FullName}} {{this.FormSubmitted.Submitted | date: 'YYYY-MM-dd HH:mm'}}</td>
      </tr>
      @if (this.FormSubmitted.UpdatedByUser) {
        <tr>
          <td>Updated by:</td>
          <td style="color: white;">{{this.FormSubmitted.UpdatedByUser.FullName}} {{this.FormSubmitted.Updated | date: 'YYYY-MM-dd HH:mm'}}</td>
        </tr>
      }
    </table>
  }

  <mat-divider></mat-divider>
</mat-card-content>
<mat-card-actions>
  @if (this.FormSubmitted.IsEditable) {
    <button mat-button [routerLink]="['/formsubmission/edit', this.FormSubmitted.SubmissionId]">EDIT</button>
  }
  @if (this.FormSubmitted.IsEditable) {
    <button mat-button (click)="deleteSubmission(this.FormSubmitted.SubmissionId)">DELETE</button>
  }
</mat-card-actions>
</mat-card>

